/**
 * Display formatting for the composite variant key.
 *
 * Extraction stamps every row with a positional key identifying the whole vehicle —
 * one segment per identity column of the DRA ktype catalogue, currently nineteen of
 * them:
 *
 *     LEXUS|LC500||2020||2UR-GSE|4969|petrol|||||8||Petrol Engine||PC|2020|2021
 *
 * Every position is always present, because that is what makes the key parseable:
 * mapping reads the engine code at index 5, the Excel export splits it into columns by
 * position, and rows are grouped on the raw string. A handbook rarely prints all
 * eighteen facts, so the runs of empty separators are load-bearing, not noise.
 *
 * They are still unreadable. This is the only place that changes: the empty segments
 * are dropped for the label a human sees, and nothing else — grouping, filtering and
 * export all keep using the raw value.
 */

const SEPARATOR = "|";

/**
 * The variant key with its empty segments removed, for display only.
 *
 * A free-text variant from a document extracted before the composite key
 * (`PETROL 4ZE1`) contains no separator and passes through untouched.
 */
export const formatVariantLabel = (variant: string): string =>
  variant
    .split(SEPARATOR)
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0)
    .join(SEPARATOR);

export default formatVariantLabel;
